import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

const DeleteAllConfirmModal = ({ isOpen, onClose, onConfirm, questionCount }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-50 transition-opacity"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl border-2 border-gray-300 max-w-md w-full overflow-hidden shadow-2xl">
          {/* Header */}
          <div className="flex items-start justify-between p-6 border-b border-gray-200 bg-red-50">
            <div className="flex items-start gap-3">
              <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
                <AlertTriangle className="text-red-600" size={24} />
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-900">Delete All Questions?</h2>
                <p className="text-sm text-gray-600 mt-1">
                  This action cannot be undone without using undo
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="p-1 hover:bg-red-100 rounded-lg transition-colors"
            >
              <X size={20} className="text-gray-500" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <p className="text-gray-700 mb-4">
              You are about to delete <span className="font-bold text-red-600">{questionCount} {questionCount === 1 ? 'question' : 'questions'}</span> from this form.
            </p>
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
              <p className="text-sm text-yellow-800">
                <strong>Note:</strong> You can undo this action using Ctrl+Z (Cmd+Z on Mac) or the Undo button.
              </p>
            </div>
            <p className="text-sm text-gray-600">
              Are you sure you want to continue?
            </p>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-3 p-6 bg-gray-50 border-t border-gray-200">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-lg text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 font-medium transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              className="px-4 py-2 rounded-lg text-white bg-red-600 hover:bg-red-700 font-medium transition-colors"
            >
              Delete All Questions
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteAllConfirmModal;
